import { HEALTH_COLORS } from './constants';

import { PoolRow } from '@/services/preferredPoolsAPI';
import styled from '@/styles';

// ui-prototype/preferred-worker-pool/client-detail.html #poolChips. The chips
// are shortcuts, not the full pool list (plan F4/edge #21). The prototype
// hardcodes three "Frequently used" skills; with real data we surface the
// three thinnest pools (the server's ascending order), which are the ones ops
// most needs one click away.

const CHIP_LIMIT = 3;

const Row = styled('div', {
  display: 'flex',
  gap: 12,
  alignItems: 'center',
  flexWrap: 'wrap',
});

const Label = styled('span', {
  fontSize: '14px',
  fontWeight: 600,
  color: '#1C1C1C',
  whiteSpace: 'nowrap',
});

const Chips = styled('div', {
  display: 'flex',
  gap: 16,
  flexWrap: 'wrap',
});

const Chip = styled('button', {
  all: 'unset',
  background: '#FCFCFC',
  border: '1px solid #DADADA',
  borderRadius: 8,
  height: 32,
  padding: '0 16px',
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  fontSize: '14px',
  color: '#1C1C1C',
  cursor: 'pointer',
  variants: {
    active: {
      true: {
        background: 'rgba(231,244,230,0.4)',
        border: '1.5px solid #44A735',
        '& .chip-name': { fontWeight: 700 },
      },
    },
  },
});

const Dot = styled('span', {
  width: 8,
  height: 8,
  borderRadius: '50%',
  flexShrink: 0,
});

type Props = {
  pools: PoolRow[];
  selectedPoolId: number | null;
  onSelect: (poolId: number) => void;
};

const PoolChips = ({ pools, selectedPoolId, onSelect }: Props) => (
  <Row>
    <Label>Frequently used</Label>
    <Chips data-testid="poolChips">
      {pools.slice(0, CHIP_LIMIT).map((pool) => (
        <Chip
          key={pool.id}
          active={pool.id === selectedPoolId}
          type="button"
          onClick={() => onSelect(pool.id)}
        >
          <Dot style={{ background: HEALTH_COLORS[pool.health] }} />
          <span className="chip-name">{pool.skill.name}</span>
          <span style={{ color: '#5B5B5B' }}>
            ({pool.active_member_count}/{pool.target_depth})
          </span>
        </Chip>
      ))}
    </Chips>
  </Row>
);

export default PoolChips;
